class Loadmore extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init(){
    const _this = this;
    this.button = this.querySelector("button");
    if (!this.button) return;
    this.button.addEventListener("click", function() {
      _this.scanData();
    });
  }
  scanData() {
    const _this = this;
    const currentUrl = window.location.href;
    const param = window.location.search;
    let url = this.dataset.url;
    if (!url) return;
    if (param.length > 0) {
      url = currentUrl+url.replaceAll("?", "&");
    }
    this.classList.add("loading");
    /* Pages can contribute 0 visible cards: imageless configurator products are
       skipped by card-product but still count toward server-side pagination.
       Track how many cards this fetch actually added so we can auto-continue. */
    this._lastAdded = null;
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = parser.parseFromString(text, "text/html");
        if (!this.closest(".section-main-collection")) return;
        if (!this.closest(".section-main-collection").querySelector(".ajax-loadmore")) return;
        if (!html.querySelector(".section-main-collection .ajax-loadmore")) return;
        const animations = this.closest(".section-main-collection").querySelectorAll(".scroll-trigger");
        if (animations.length !== 0) {
          animations.forEach(e => {
            e.classList.remove("scroll-trigger");
          });
        }
        this._lastAdded = html.querySelector(".section-main-collection .ajax-loadmore").querySelectorAll(".product-wrapper").length;
        this.closest(".section-main-collection").querySelector(".ajax-loadmore").innerHTML += html.querySelector(".section-main-collection .ajax-loadmore").innerHTML;
        if (this.closest(".section-main-collection").querySelector(".ajax-loadmore .counting_product")) {
          this.closest(".section-main-collection").querySelector(".ajax-loadmore .counting_product").remove();
        }
        this.updateCountText();
      })
      .finally(() => {
        initLazyloadItem();
        if (window.SPR) {
          window.SPR.registerCallbacks();
          window.SPR.initRatingHandler();
          window.SPR.initDomEls();
          window.SPR.loadProducts();
          window.SPR.loadBadges();
        }
        _this.updateUrl(Number(this.dataset.url.replace("?page=","")));
        this.classList.remove("loading");
        /* This page rendered nothing visible and more pages remain (button not
           removed by updateUrl) → fetch the next page right away, so one click
           always yields new products or ends the list. */
        if (this._lastAdded === 0 && this.querySelector("button")) {
          this.scanData();
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
  /* "Je hebt N resultaten bekeken" — count the cards actually in the grid;
     server-side totals overstate (they include skipped imageless products). */
  updateCountText() {
    const section = this.closest(".section-main-collection");
    const label = this.querySelector(".counting_product");
    if (!section || !label) return;
    const grid = section.querySelector(".ajax-loadmore");
    if (!grid) return;
    const visible = grid.querySelectorAll(".product-wrapper").length;
    const tpl = visible === 1 ? this.dataset.countOne : this.dataset.countOther;
    if (tpl) label.textContent = tpl.replace("[count]", visible);
  }
  updateUrl(e) {
    const all = this.dataset.allProducts;
    const limit = this.dataset.limit;
    if (all && limit && all > 0 ) {
      const times = ~~(all/limit);
      const remainder = all%limit;
      let pages = times;
      if (remainder > 0) {
        pages = times + 1;
      }
      if (e<pages) {
        this.dataset.url = "?page="+(++e);
      }else{
        const btn = this.querySelector("button");
        if (btn) {
          btn.remove();
        }
      }
    }
  }
}
customElements.define("loadmore-button-collection", Loadmore);

if (!customElements.get('loadmore-infinity')) {
  customElements.define('loadmore-infinity', class LoadInfinity extends Loadmore {
    constructor() {
      super();
    }
    init(){
      this.getHeightBtn();
    }
    getHeightBtn() {
      const _this = this;
      this.btn = this.querySelector("button");
      if (!this.querySelector("button")) return;
      var isVisible = false;
      window.addEventListener('scroll', function() {
        var buttonRect = _this.btn.getBoundingClientRect();
        var viewportHeight = window.innerHeight;
        if (!isVisible && buttonRect.top<=viewportHeight) {
          isVisible = true;
          _this.scanData();
      } else if (isVisible && buttonRect.top>viewportHeight) {
          isVisible = false;
      }
      });
  }
  });
}